import { useState } from 'react';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import LogoutIcon from '@mui/icons-material/Logout';

import { Channel, ChannelMemberResponse } from 'stream-chat';
import { useChatContext } from 'stream-chat-react';
import { useNotificationStore } from '@/stores/notificationstore';
import { useTranslation } from 'react-i18next';
import { updateMemberState } from '@/generated/client/chat/chat';

export default function PreviewButtons({ channel }: { channel: Channel }) {
  const { client } = useChatContext();
  const { t } = useTranslation();
  const showNotification = useNotificationStore((state) => state.showNotification);
  const [isMuted, setIsMuted] = useState(channel.muteStatus().muted);

  async function leaveChannel() {
    const userId = client.user?.id;
    const response = await channel.queryMembers({});
    if (!canLeaveChannel(response.members)) {
      showNotification('warning', t('streamChat.custom.cannotLeaveChannel'), undefined, 5);
      return;
    }
    await channel.sendMessage({
      text: `${client.user?.name} ${t('streamChat.custom.leftChannel')}`,
      type: 'system',
    });
    await channel.removeMembers([userId!]);
    await updateMemberState({ channelId: channel.id! });
  }

  function canLeaveChannel(members: ChannelMemberResponse[]) {
    for (const member of members) {
      if (member.user?.role !== 'driver') {
        continue;
      }
      if (member.user.deactivated_at) {
        return true;
      } else {
        return members.length > 2;
      }
    }
    return true;
  }

  async function muteChannel() {
    if (channel.muteStatus().muted) {
      await channel.unmute();
      setIsMuted(false);
    } else {
      await channel.mute();
      setIsMuted(true);
    }
  }

  function canLeave() {
    return channel.type === 'ONE_DISP_ONE_DRIVER';
  }

  return (
    <div className="str-chat__channel-preview__action-buttons">
      <button className="str-chat__channel-preview__action-button" title="Mute/unmute channel" onClick={muteChannel}>
        {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
      </button>
      {canLeave() && (
        <button className="str-chat__channel-preview__action-button" title="Leave channel" onClick={leaveChannel}>
          <LogoutIcon />
        </button>
      )}
    </div>
  );
}
